// For Firebase JS SDK v7.20.0 and later, measurementId is optional


export const firebaseConfig = {
  apiKey: "AIzaSyBvPAUtAC1rx8Udyq0zzz6pqXENiuKrrMc",
  authDomain: "challenge-688ac.firebaseapp.com",
  databaseURL: "https://challenge-688ac-default-rtdb.firebaseio.com",
  projectId: "challenge-688ac",
  storageBucket: "challenge-688ac.appspot.com",
  messagingSenderId: "475175958855",
  appId: "1:475175958855:web:c902d776f066b40a433462",
  measurementId: "G-WYZ02Q4MRW"
};

